export default __webpack_public_path__ + "static/media/OBP.82a5e5be.svg";